<script>
    import Notification from '../../States/Notification'
    import Conference from '../../States/Conference'
</script>

<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                © Flaire
            </div>
        </div>
    </div>
</footer>

{#if $Notification.incoming.length && !$Conference.call.active}
    <audio autoplay style="display: none;">
        <source src="/sound/notification.mp3" type="audio/mpeg">
    </audio>
{/if}